import PROCTORING_TYPE from '../enums/proctoringType'
import REPORT_STATE from '../enums/reportState'

const canShowAttemptReport = attempt =>
    attempt?.report?.state === REPORT_STATE.PUBLISHED ||
    (attempt?.extras?.is_preview === true && !!attempt?.report)

const applyPreviewAssessmentConfig = (assessment, isPreview) => {
    if (!isPreview) return assessment
    return {
        ...assessment,
        proctoring: PROCTORING_TYPE.NO_PROCTORING,
        full_screen_mode: false,
        full_screen_integrity_mode: false,
        is_key_required: false,
        disable_high_integrity_checks: true,
        retry: { ...(assessment?.retry || {}), delay: 0 },
    }
}
export { applyPreviewAssessmentConfig, canShowAttemptReport }
